<app-replacement-claim-overview [filter]="'delivered'" [pageTitle]="'Te leveren vervangsaanvragen'"></app-replacement-claim-overview>
